var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 梦鱼专属测试文件 "),_c('form-money-input',{attrs:{"formData":_vm.formData,"renderSence":"edit","propKey":"money","widget":{
      label: '金额组件',
      placeholder: '请输入金额',
      numberMax: 200
    }}}),_c('form-email-input',{attrs:{"formData":_vm.formData,"renderSence":"read","propKey":"email","widget":{
      label: '邮箱组件',
      placeholder: '请输入邮箱'
    }}}),_c('form-phone-input',{attrs:{"formData":_vm.formData,"renderSence":"edit","propKey":"phone","widget":{
      label: '手机号组件',
      placeholder: '请输入手机号'
    }}}),_c('form-idcard-input',{attrs:{"formData":_vm.formData,"renderSence":"edit","propKey":"idcard","widget":{
      label: '证件号组件',
      placeholder: '请输入身份证号'
    }}}),_c('form-document-number',{attrs:{"formData":_vm.formData,"renderSence":"edit","propKey":"docuemntNumber","widget":_vm.documentNumberWidget}}),_c('cube-button',{on:{"click":_vm.handleClick}},[_vm._v(" 测试dialog ")]),_c('form-upload',{attrs:{"renderSence":"edit","formData":_vm.formData,"propKey":"upload","widget":{
      fileMaxSize: 1,
      fileMaxNum: 1,
      fileType: ['img', 'word'],
      label: '上传组件'
    }}}),_c('cube-button',{on:{"click":_vm.handleOpen}},[_vm._v(" 打开弹框 ")]),_c('x-modal',{attrs:{"title":"审批历史","visible":_vm.visible},on:{"update:visible":function($event){_vm.visible=$event}}}),_c('approval-history',{ref:"approvalHistory"}),_c('form-department-select',{attrs:{"formData":_vm.formData,"renderSence":"edit","propKey":"department","widget":{
      label: '部门选择'
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }